import classNames from 'classnames';

import Loader from '../Loader';

import useStyles from './styles';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { ReactComponent as FileIcon } from './icon.svg';

export interface IFileLoader {
  className?: string;
}

function FileLoader({ className }: IFileLoader) {
  const classes = useStyles();

  return (
    <div className={classNames(className, classes.root)}>
      <FileIcon className={classes.fileIcon} />
      <div className={classes.progressIconContainer}>
        <Loader className={classNames(classes.progressIcon, 'svg-loader')} />
      </div>
    </div>
  );
}

export default FileLoader;
